// extracted by mini-css-extract-plugin
export default {"pplive":"index_pplive_t9OtS","list":"index_list_bbiXh"};